import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const MiddleName = props => (
  <BaseInput
    label="Middle Name"
    type="text"
    name="middle"
    maxLength="30"
    transparent
    data-cv-test="middleName"
    validate={val =>
      string()
        .notRequired()
        .matches(/^[a-zA-Z0-9 \-']+$/, {
          message: 'Enter a valid value',
          excludeEmptyString: true
        })
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

MiddleName.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

MiddleName.defaultProps = {
  error: false
};

export default MiddleName;
